<template>
    <div class="edit-personal-info">
        <NameCard/>

        <van-form @submit="onSubmit" class="form">
            <h3 class="form-title">编辑个人信息</h3>

            <div class="round-corner">
                <van-field
                    v-model="user.telMobile1"
                    name="手机号码"
                    label="手机号码"
                    placeholder="请输入手机号码"
                />
                <van-field
                    v-model="user.telMobile2"
                    name="微信号"
                    label="微信号"
                    placeholder="请输入微信号"
                />
                <van-field
                    v-model="user.telOffice"
                    name="办公电话"
                    label="办公电话"
                    placeholder="请输入办公电话"
                />
                <van-field
                    v-model="user.telHome"
                    name="家庭电话"
                    label="家庭电话"
                    placeholder="请输入家庭电话"
                />
                <van-field
                    v-model="user.email"
                    name="电子邮箱"
                    label="电子邮箱"
                    placeholder="请输入电子邮箱"
                />
                <van-field
                    v-model="user.address"
                    name="联系地址"
                    label="联系地址"
                    placeholder="请输入联系地址"
                />
                <van-field
                    v-model="user.postalCode"
                    name="邮政编码"
                    label="邮政编码"
                    placeholder="请输入邮政编码"
                />
            </div>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    保存
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import {Form, Field, Button, Toast} from 'vant'
import NameCard from "@/components/NameCard/NameCard"
import {setupUserInfo} from "@/api/address-book";
import {queryUser} from "@/api";

export default {
    name: 'EditPersonalInfo',
    components: {
        NameCard,
        [Form.name]: Form,
        [Field.name]: Field,
        [Button.name]: Button,
    },
    props: ['uuid'],
    data() {
        return {
            user: {},
        }
    },
    computed: {},
    methods: {
        onSubmit() {
            setupUserInfo({id: this.user.userId, ...this.user})
                .then(resp => {
                    if (resp && resp.code == '200') {
                        Toast.success('保存成功')
                    } else {
                        Toast.fail('保存失败')
                    }
                })
                .catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))
        },
    },
    created() {
        queryUser(this.uuid)
            .then(user => this.user = user)
            .catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))
    }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.edit-personal-info {
    .form {
        padding: 0 15px;
    }

    .form-title {
        color: #666666;
        font-weight: 400;
        padding: 10px 0;
        @extend .font14;
    }
}
</style>
